import React, { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { productMap } from '@src/utils/aiAlerts/metrics';
import { fullSensitivityConfigAtom, selectedProductAtom } from '../../atoms';
import SensitivityRows from './SensitivityRows';
import { FeatureMsgWrapper, FeatureText } from '@src/components/common/FeatureCheck/styled';
import AdSensitivityRows from './AdSensitivityRows';
import { PRODUCT_MODE_MAP } from '@src/utils/constants';

type NullableNumber = number | null;

export type sensitivityConfig = {
  app?: string;
  asf?: number;
  criticalImpactedUnique?: NullableNumber;
  criticalImpactedUniquePct?: NullableNumber;
  criticalPcpDrop?: NullableNumber;
  criticalSustain?: NullableNumber;
  customerId?: number;
  deviation?: string;
  id?: number;
  impactedUnique?: NullableNumber;
  impactedUniquePct?: NullableNumber;
  metric: string;
  metricKey: string;
  sustain?: NullableNumber;
  sustainPcpDrop?: NullableNumber;
  updatedAt?: string;
  updatedById?: number;
  warningImpactedUnique?: NullableNumber;
  warningImpactedUniquePct?: NullableNumber;
  warningPcpDrop?: NullableNumber;
  warningSustain?: NullableNumber;
};

const SensitivityForm = () => {
  const fullSensitivityData = useAtomValue(fullSensitivityConfigAtom);
  const [currentProductSensitivity, setCurrentProductSensitivity] = useState([]);
  const selectedProduct = useAtomValue(selectedProductAtom);

  useEffect(() => {
    if (fullSensitivityData) {
      setCurrentProductSensitivity(
        fullSensitivityData.filter(
          (sensitivity) => sensitivity.app === productMap[selectedProduct],
        ),
      );
    }
  }, [fullSensitivityData, selectedProduct]);

  return (
    <div style={{ paddingTop: '15px' }}>
      {currentProductSensitivity.length ? (
        currentProductSensitivity.map((sensitivityConfig) =>
          selectedProduct === PRODUCT_MODE_MAP.AI ? (
            <AdSensitivityRows key={sensitivityConfig.metric} sensitivity={sensitivityConfig} />
          ) : (
            <SensitivityRows key={sensitivityConfig.metric} sensitivity={sensitivityConfig} />
          ),
        )
      ) : (
        <FeatureMsgWrapper>
          <FeatureText>
            {`${selectedProduct} metrics are not available for sensitivity configuration. Contact your Conviva representative for more information.`}
          </FeatureText>
        </FeatureMsgWrapper>
      )}
    </div>
  );
};

export default React.memo(SensitivityForm);
